import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import { IncidentCellListExportRequest, IncidentCellListUploadRequest } from '../requests/IncidentCellListRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const IncidentCellListExport = (userId) => async (dispatch) => {
	await IncidentCellListExportRequest(userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const IncidentCellListUpload = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		IncidentCellListUploadRequest(response.data, userId).then(response2 => {
			if (response2.data.includes('uploaded with success')) {
				dispatch(IncidentCellListExport(userId));
			} else {
				dispatch(enqueueSnackbar({ message: 'Upload fail', options: { variant: 'error' } }));
			}
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
